(function () {
    'use strict';

    angular
        .module('sod-logger')
        .config(configFunc);

    function configFunc(SodLoggerProvider, SodEnvironmentContants) {
        const env = angular.element('body').attr('data-environment');
        SodLoggerProvider.config((env !== SodEnvironmentContants.PRODUCTION) ? env : SodEnvironmentContants.PRODUCTION);
    }
})();